var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-interactjs',{attrs:{"widget":_vm.widget,"minw":100,"minh":30}},_vm._l((_vm.widget.d),function(item,index){return (_vm.widget)?_c('div',{key:index,staticClass:"outer"},[_c('div',{staticClass:"inner",style:({textAlign: _vm.widget.a})},[_c('i',{staticClass:"material-icons"},[_vm._v(_vm._s(item.c ? 'radio_button_checked' : 'radio_button_unchecked')+" ")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.n))])])]):_vm._e()}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8cd5c9c6","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/WidgetRadio.vue
// module id = 91
// module chunks = 0